import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["onChange", "setRef", "value", "onInput"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

var CInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(CInput, _PureComponent);

  var _super = _createSuper(CInput);

  function CInput() {
    _classCallCheck(this, CInput);

    return _super.apply(this, arguments);
  }

  _createClass(CInput, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          onChange = _this$props.onChange,
          setRef = _this$props.setRef,
          value = _this$props.value,
          _onInput = _this$props.onInput,
          other = _objectWithoutProperties(_this$props, _excluded);

      if (value !== this.lastValue) {
        this.value = value;
      }

      this.lastValue = value;
      return /*#__PURE__*/React.createElement("input", _extends({
        value: this.inComposition ? this.value || '' : value,
        ref: setRef,
        onChange: function onChange() {},
        onCompositionStart: function onCompositionStart() {
          _this.inComposition = true;

          _this.forceUpdate();
        },
        onCompositionEnd: function onCompositionEnd(e) {
          _this.inComposition = false;
          onChange(e);
        },
        onInput: function onInput(e) {
          _this.value = e.target.value;

          if (!_this.inComposition) {
            onChange(e);
          } else {
            _this.forceUpdate();
          }

          _onInput(e.target.value);
        }
      }, other));
    }
  }]);

  return CInput;
}(PureComponent);

export { CInput as default };
CInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  setRef: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onInput: PropTypes.func
};
CInput.defaultProps = {
  setRef: function setRef() {},
  value: '',
  onInput: function onInput() {}
};